import clsx from 'clsx';

import type { EventStatus } from '../data';
import s from '../page.module.scss';

const STATUS_LABEL: Record<string, string> = {
  live:       '진행 중',
  soon:       '마감 임박',
  always:     '상시',
  recruiting: '모집 중',
};

interface HubEventStatusBadgesProps {
  status: EventStatus;
  subLabel?: string;
  size?: 'small' | 'medium';
}

export function HubEventStatusBadges({ status, subLabel, size }: HubEventStatusBadgesProps) {
  const badge = clsx(s.badge, size === 'small' && s.badge_small);

  return (
    <div className={s.status_badges}>
      {subLabel && (
        <span className={clsx(badge, s.badge_category)}>{subLabel}</span>
      )}
      <span className={clsx(badge, s[`badge_${status.main}`])}>
        {STATUS_LABEL[status.main]}
      </span>
      {status.sub && (
        <span className={clsx(badge, s.badge_recruiting)}>
          {STATUS_LABEL[status.sub]}
        </span>
      )}
    </div>
  );
}
